import { Component, OnInit } from '@angular/core';
import { CoreService } from '../core/_services/core.services';

@Component({
  selector: 'app-evaluacion-competencias',
  templateUrl: './evaluacion-competencias.component.html',
  styleUrls: ['./evaluacion-competencias.component.scss']
})
export class EvaluacionCompetenciasComponent implements OnInit {

  mostrarFormulario: boolean = false;
  columnas: any[] = [];
  competenciasLista: any[] = [];
  cargando: boolean = false;
  seleccionado: boolean = false;
  registroSeleccionado: any;

  // Paginador
  pageSize: Number = 10;
  paginationOptions = {
    pageNumber: 1,
    rows: this.pageSize,
    pageLinkSize: 3,
    rowsPerPageOptions: [this.pageSize, 10, 15],
    totalRecords: 0
  };

  constructor(
    public coreService: CoreService
  ) { }

  ngOnInit(): void {
    this.columnas = [
      { field: 'requerimientos_id', header: 'Requisición' },
      { field: 'profesional_id', header: 'Psicólogo' },
      { field: 'descripcion', header: 'Descripción' },
      { field: 'fecha', header: 'Fecha' }
    ];
    this.getCompetenciasLista();
  }

  getCompetenciasLista() {
    this.coreService.get('/evaluacion').subscribe(
      (res: any) => {
        this.competenciasLista = res;
        this.paginationOptions.totalRecords = this.competenciasLista.length;
        console.log(this.competenciasLista)
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  cambioPagina(event){
    this.paginationOptions.rows = event.rows;
    this.paginationOptions.pageNumber = (event.first / event.rows)+1;
    this.getCompetenciasLista();
  }

  agregar() {
    this.mostrarFormulario = true;
  }

  volver() {
    this.seleccionado = false;
    this.registroSeleccionado = null;
  }

  ver(data) {
    this.seleccionado = true;
    this.registroSeleccionado = data;
  }

}
